import React, { useEffect, useState } from 'react';
import styles from './ButtonAddToWishlistAllProduct.module.scss';
import { addCustomPathToLink, checkIsFavourite, toggleFavourite } from '../../../../functions';

const ButtonAddToWishlistAllProducts = ({ productsList }) => {
  const [isAllFavourites, setIsAllFavourites] = useState(false);

  useEffect(() => {
    const localStorageSetHandler = () => {
      productsList.every((productID) => {
        if (!checkIsFavourite(productID)) {
          setIsAllFavourites(false);
          return false;
        }
        if (!isAllFavourites) setIsAllFavourites(true);
        return true;
      });
    };

    localStorageSetHandler();
    document.addEventListener('itemInserted', localStorageSetHandler, false);
    return (_) => {
      document.removeEventListener('itemInserted', localStorageSetHandler, false);
    };
  }, [productsList]);

  return (
    <div
      className={styles.boxWishlist}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleFavourite(productsList, isAllFavourites);
      }}
    >
      <div className={styles.boxWrapper}>
        <div className={styles.boxButtonWrapper}>
          <img className={styles.arrow} src={addCustomPathToLink('/images/arrow-black-next.svg', true)} />
          <button className={styles.btnWishListAll}>
            Dodaj
            <br /> wszystkie produkty
            <br /> do listy życzeń
          </button>
        </div>
        {isAllFavourites ? (
          <img className={styles.heart} src={addCustomPathToLink('/images/green-heart-full.svg', true)} />
        ) : (
          <img className={styles.heart} src={addCustomPathToLink('/images/black-heart.svg', true)} />
        )}
      </div>
    </div>
  );
};
export default ButtonAddToWishlistAllProducts;
